<template>
  <b-dropdown
    right
    :boundary="boundary"
    no-caret
    variant="link"
    menu-class="services-menu"
    :toggle-class="toggleClass"
  >
    <template #button-content>
      Services
    </template>
    <areas-nav-item />
    <awards-nav-item v-if="awardsEnabled" />
    <conferences-nav-item />
  </b-dropdown>
</template>

<script>
import AreasNavItem from '@/views/components/nav/AreasNavItem.vue';
import AwardsNavItem from '@/views/components/nav/AwardsNavItem.vue';
import ConferencesNavItem from '@/views/components/nav/ConferencesNavItem.vue';

const SERVICES_ACTIVE_ROUTES = [
  'TechnicalAreas',
  'TechnicalAreasEdit',
  'TechnicalAreasEditKeywords',
  'TechnicalAreasValidate',
  'Awardees',
  'Nominations',
  'NominationsCreate',
  'NominationsEdit',
  'References',
  'ReferencesEdit',
  'Reviews',
  'ReviewsEdit',
  'Decisions',
  'ReportsEdit',
  'Conferences',
  'Approvals',
  'ConferencesAll',
  'ConferencesPublicDisplay',
];

export default {
  name: 'ServicesNavItem',
  components: {
    AreasNavItem,
    AwardsNavItem,
    ConferencesNavItem,
  },
  props: {
    mobileHide: {
      type: Boolean,
      default: true,
    },
    boundary: {
      type: String,
      default: 'scrollParent',
    },
  },
  computed: {
    awardsEnabled() {
      return process.env.VUE_APP_AWARDS_ENABLED !== 'false';
    },
    toggleClass() {
      return [
        'nav-link',
        {
          active: SERVICES_ACTIVE_ROUTES.includes(this.$route.name),
        },
        { 'mobile-hide': this.mobileHide },
      ];
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/base/_mixins.scss";

.services-menu {
  @include media(tablet) {
    width: 19rem;
    max-width: calc(100vw - 1.5rem);

    .dropdown-item {
      white-space: normal;
    }
  }
}
</style>
